module.exports = __webpack_public_path__ + "img/forward.16bbd97a.svg";